import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicTestimonialsSimple {
  constructor(section) {
    initCarousel(
      section.el,
      {
        perPage: 1,
        type: 'fade',
        rewind: true,
        pagination: true,
        arrows: false,
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.md]: {
            arrows: true,
            padding: {
              right: '4rem',
              left: '4rem',
            },
          },
          [unitlessBreakpoints.lg]: {
            padding: {
              right: '6rem',
              left: '6rem',
            },
          },
        },
      },
      true,
    );
  }
}
